import type { BudgetPost } from '@/api/generated';

// BF-13 — single source of truth that bridges the backend BudgetPost enum
// keys with the SPA's display labels and URL slugs. The order matches the
// design's BUDGET_POSTS reference list (Budget.tsx) so the stacked-bar
// segments stay in the same visual order.

export interface BudgetPostMeta {
  id: BudgetPost;
  slug: string;
  label: string;
}

export const BUDGET_POSTS: ReadonlyArray<BudgetPostMeta> = [
  { id: 'GrondNotaris', slug: 'grond-notaris', label: 'Grond + notaris' },
  { id: 'ArchitectStudies', slug: 'architect-studies', label: 'Architect + studies' },
  { id: 'VergunningenNuts', slug: 'vergunningen-nuts', label: 'Vergunningen + nuts.' },
  { id: 'Ruwbouw', slug: 'ruwbouw', label: 'Ruwbouw' },
  { id: 'Dakwerken', slug: 'dakwerken', label: 'Dakwerken' },
  { id: 'RamenSchrijnwerk', slug: 'ramen-schrijnwerk', label: 'Ramen + buitenschrijnwerk' },
  { id: 'Technieken', slug: 'technieken', label: 'Technieken (elek/sanitair/HVAC)' },
  { id: 'IsolatieGyproc', slug: 'isolatie-gyproc', label: 'Isolatie + gyproc' },
  { id: 'VloerenTegels', slug: 'vloeren-tegels', label: 'Vloeren + tegels' },
  { id: 'Keuken', slug: 'keuken', label: 'Keuken' },
  { id: 'Binnenschrijnwerk', slug: 'binnenschrijnwerk', label: 'Binnenschrijnwerk' },
  { id: 'SanitairToestellen', slug: 'sanitair-toestellen', label: 'Sanitair (toestellen)' },
  { id: 'TuinOpritten', slug: 'tuin-opritten', label: 'Tuin + opritten' },
  { id: 'Diversen', slug: 'diversen', label: 'Diversen' },
  { id: 'Onvoorzien', slug: 'onvoorzien', label: 'Onvoorzien' },
];

export function budgetPostBySlug(slug: string): BudgetPostMeta | undefined {
  return BUDGET_POSTS.find((p) => p.slug === slug);
}

export function budgetPostById(id: BudgetPost): BudgetPostMeta | undefined {
  return BUDGET_POSTS.find((p) => p.id === id);
}

/** Display label fallback for an unrecognised post id (shouldn't happen). */
export function budgetPostLabel(id: BudgetPost | null | undefined): string {
  if (!id) return 'Ongesorteerd';
  return budgetPostById(id)?.label ?? id;
}
